(() => {
  const AUTOPLAY_DELAY = 10000;
  const swiperEl = document.querySelector(".full-swiper-left");
  const paginationEl = document.querySelector(
    "#hero-header-left-swiper-pagination",
  );

  if (!swiperEl || !paginationEl || typeof Swiper === "undefined") return;

  const wrapperEl = swiperEl.querySelector(".swiper-wrapper");
  const slideCount = wrapperEl
    ? Array.from(wrapperEl.children).filter((slide) =>
        slide.classList.contains("swiper-slide"),
      ).length
    : 0;
  const reducedMotionQuery = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  );
  const shouldAutoplay = slideCount > 1 && !reducedMotionQuery.matches;
  let isAutoplayPaused = false;
  let isHoverPaused = false;
  let isFocusPaused = false;
  let needsAutoplayRestart = false;
  let currentActiveProgress = shouldAutoplay ? 0 : 1;
  let touchStartIndex = null;

  let heroSwiperLeft;

  heroSwiperLeft = new Swiper(swiperEl, {
    loop: slideCount > 1,
    slidesPerView: 1,
    autoHeight: false,
    spaceBetween: 0,
    speed: 400,
    allowTouchMove: slideCount > 1,
    watchOverflow: true,

    autoplay: shouldAutoplay
      ? {
          delay: AUTOPLAY_DELAY,
          disableOnInteraction: false,
          waitForTransition: false,
        }
      : false,

    observer: true,
    observeParents: true,
    resizeObserver: true,

    pagination: {
      el: "#hero-header-left-swiper-pagination",
      clickable: true,
      type: "bullets",
    },

    on: {
      init(swiper) {
        refreshHeroSwiper(swiper);
        resetPaginationProgress(shouldAutoplay ? 0 : 1);
      },
      imagesReady(swiper) {
        refreshHeroSwiper(swiper);
      },
      paginationRender() {
        resetPaginationProgress(currentActiveProgress);
      },
      slideChange() {
        resetPaginationProgress(shouldAutoplay ? 0 : 1);
      },
      touchStart(swiper) {
        touchStartIndex = swiper.activeIndex;
      },
      slideChangeTransitionEnd(swiper) {
        // sometimes content changes after transition
        refreshHeroSwiper(swiper);
      },
      touchEnd(swiper) {
        if (touchStartIndex !== null && touchStartIndex !== swiper.activeIndex) {
          restartAutoplay(swiper);
        }

        touchStartIndex = null;
      },
      autoplayTimeLeft(swiper, timeLeft, progress) {
        if (!shouldAutoplay) return;
        updateActivePaginationProgress(1 - progress);
      },
    },
  });

  let resizeTimer;

  function getPaginationBullets() {
    return Array.from(
      paginationEl.querySelectorAll(".swiper-pagination-bullet"),
    );
  }

  function clampProgress(progress) {
    if (!Number.isFinite(progress)) return 0;
    return Math.min(Math.max(progress, 0), 1);
  }

  function setPaginationBulletProgress(bullet, progress) {
    bullet.style.setProperty("--hero-progress", clampProgress(progress));
  }

  function resetPaginationProgress(activeProgress = 0) {
    currentActiveProgress = clampProgress(activeProgress);
    paginationEl.classList.add("is-resetting-progress");

    getPaginationBullets().forEach((bullet) => {
      setPaginationBulletProgress(
        bullet,
        bullet.classList.contains("swiper-pagination-bullet-active")
          ? currentActiveProgress
          : 0,
      );
    });

    requestAnimationFrame(() => {
      paginationEl.classList.remove("is-resetting-progress");
    });
  }

  function updateActivePaginationProgress(progress) {
    const activeBullet = paginationEl.querySelector(
      ".swiper-pagination-bullet-active",
    );

    if (!activeBullet) return;

    currentActiveProgress = clampProgress(progress);
    setPaginationBulletProgress(activeBullet, currentActiveProgress);
  }

  function restartAutoplay(swiper = heroSwiperLeft) {
    if (!shouldAutoplay || !swiper || !swiper.autoplay) return;

    resetPaginationProgress(0);
    swiper.autoplay.stop();

    if (isAutoplayPaused) {
      needsAutoplayRestart = true;
      return;
    }

    needsAutoplayRestart = false;
    swiper.autoplay.start();
  }

  function pauseAutoplay(swiper = heroSwiperLeft) {
    if (!shouldAutoplay || !swiper || !swiper.autoplay) return;

    isAutoplayPaused = true;
    swiper.autoplay.pause();
  }

  function resumeAutoplay(swiper = heroSwiperLeft) {
    if (!shouldAutoplay || !swiper || !swiper.autoplay) return;

    isAutoplayPaused = false;

    if (needsAutoplayRestart) {
      needsAutoplayRestart = false;
      swiper.autoplay.start();
      return;
    }

    swiper.autoplay.resume();
  }

  function syncAutoplayPauseState() {
    const shouldPause = isHoverPaused || isFocusPaused;

    if (shouldPause && !isAutoplayPaused) {
      pauseAutoplay();
      return;
    }

    if (!shouldPause && isAutoplayPaused) {
      resumeAutoplay();
    }
  }

  function equalizeSlideHeights(swiper = heroSwiperLeft) {
    if (!swiper || !swiper.slides?.length) return;

    // Clear previous forced heights
    swiper.slides.forEach((s) => (s.style.height = ""));

    // Measure only real slides (ignore loop duplicates)
    const realSlides = Array.from(swiper.slides).filter(
      (s) => !s.classList.contains("swiper-slide-duplicate"),
    );
    const slidesToMeasure = realSlides.length
      ? realSlides
      : Array.from(swiper.slides);

    let maxH = 0;
    slidesToMeasure.forEach((slide) => {
      const h = slide.offsetHeight; // safer than scrollHeight (won’t “include” overflow)
      if (h > maxH) maxH = h;
    });

    if (!maxH) return;

    swiper.slides.forEach((slide) => {
      slide.style.height = `${maxH}px`;
    });
  }

  function refreshHeroSwiper(swiper = heroSwiperLeft) {
    if (!swiper) return;

    requestAnimationFrame(() => {
      swiper.update();
      requestAnimationFrame(() => {
        equalizeSlideHeights(swiper);
        swiper.update();
      });
    });
  }

  window.addEventListener("load", () => {
    refreshHeroSwiper();
    setTimeout(refreshHeroSwiper, 150);
  });

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      refreshHeroSwiper();
      setTimeout(refreshHeroSwiper, 100);
    }, 120);
  });

  window.addEventListener("orientationchange", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      refreshHeroSwiper();
      setTimeout(refreshHeroSwiper, 150);
    }, 200);
  });

  if ("ResizeObserver" in window) {
    const ro = new ResizeObserver(() => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshHeroSwiper, 80);
    });
    ro.observe(swiperEl);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      refreshHeroSwiper();
      setTimeout(refreshHeroSwiper, 100);
    });
  }

  paginationEl.addEventListener("click", (event) => {
    if (!event.target.closest(".swiper-pagination-bullet")) return;

    restartAutoplay();
  });

  swiperEl.addEventListener("mouseenter", () => {
    isHoverPaused = true;
    syncAutoplayPauseState();
  });
  swiperEl.addEventListener("mouseleave", () => {
    isHoverPaused = false;
    syncAutoplayPauseState();
  });
  swiperEl.addEventListener("focusin", () => {
    isFocusPaused = true;
    syncAutoplayPauseState();
  });
  swiperEl.addEventListener("focusout", (event) => {
    if (event.relatedTarget && swiperEl.contains(event.relatedTarget)) return;

    isFocusPaused = false;
    syncAutoplayPauseState();
  });
})();
